module.exports = __webpack_public_path__ + "static/media/logo.fd61ef58.JPG";